import { useNavigate, useParams } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useRoom } from "../../lib/zhuyinRoom";
import { RoomShell, groupOf } from "../../components/zhuyin/RoomUI";
import { LearnPanel } from "../../components/zhuyin/LearnPanel";

const Nav = ({ to, icon: Icon, testid }) => {
  const nav = useNavigate();
  return (
    <button data-testid={testid} disabled={!to} onClick={() => nav(`/zhuyin/s/${encodeURIComponent(to.symbol)}`)}
      className="w-14 h-14 rounded-full bg-white border-2 border-[#b9dcf0] text-[#1D6FB8] flex items-center justify-center disabled:opacity-30"><Icon size={28} /></button>
  );
};

export default function ZhuyinLearn() {
  const { symbol } = useParams();
  const { cards, childId, reload } = useRoom();
  const i = cards ? cards.findIndex((z) => z.symbol === symbol) : -1;
  const z = cards?.[i];
  return (
    <RoomShell title={z ? `${groupOf(z).name}・${z.symbol}` : "注音"} testid="zhuyin-learn-page"
      right={<><Nav to={cards?.[i - 1]} icon={ChevronLeft} testid="learn-prev-btn" /><Nav to={cards?.[i + 1]} icon={ChevronRight} testid="learn-next-btn" /></>}>
      {z && <LearnPanel z={z} childId={childId} onTraced={reload} />}
    </RoomShell>
  );
}
